import React from 'react';

import { Box, Typography } from '@mui/material';

type Props = {
  icd10?: string;
  modifiers?: string;
  units?: string;
  grant?: string;
};

const AIOutputSection: React.FC<Props> = ({
  icd10,
  modifiers,
  units,
  grant,
}) => {
  const outputSection = (title: string, body: string) => (
    <Box
      sx={{
        marginTop: '32px',
        display: 'flex',
        flexDirection: 'column',
        flexGap: '32px',
      }}
    >
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 600,
          color: 'rgba(0, 33, 69, 0.75)',
          marginRight: '2px',
        }}
      >
        {title}
      </Typography>
      <pre
        style={{
          whiteSpace: 'pre-wrap',
          wordWrap: 'break-word',
          flexGrow: 1,
          position: 'relative',
          fontFamily: 'SFProDisplay-Medium',
          color: 'rgba(0, 33, 69, 0.5)',
          fontSize: 16,
          fontWeight: 400,
          lineHeight: 1.2,
          marginRight: 0,
          marginLeft: 0,
          height: '100%',
        }}
        className='small-font-on-mobile'
      >
        {body}
      </pre>
    </Box>
  );

  return (
    <>
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 600,
          color: 'rgba(0, 33, 69, 0.50)',
          marginRight: '2px',
        }}
      >
        AI OUTPUT
      </Typography>
      {icd10 && outputSection('ICD10 Response', icd10)}
      {modifiers && outputSection('Modifiers Response', modifiers)}
      {units && outputSection('Units Response', units)}
      {grant && outputSection('CCI Lawyer', grant)}
    </>
  );
};

export default AIOutputSection;
